module.exports = __webpack_public_path__ + "static/media/dragdown.f6bebc27.svg";